import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { extract } from '@app/core';
import { ProfileFormComponent } from '@app/profile-feature/components';

const routes: Routes = [
  {
    path: '',
    component: ProfileFormComponent,
    data: {
      title: extract('edit'),
      breadcrumb: 'profile'
    },
    children: [
      {
        path: 'create',
        component: ProfileFormComponent,
        data: {
          title: extract('create'),
          breadcrumb: 'profile.create'
        }
      },
      {
        path: 'edit/:id',
        component: ProfileFormComponent,
        data: {
          isEdit: true,
          title: extract('edit'),
          breadcrumb: 'profile.edit'
        }
      },
      {
        path: 'clone/:id',
        component: ProfileFormComponent,
        data: {
          isClone: true,
          title: extract('clone'),
          breadcrumb: 'profile.clone'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule {
  static components = [ProfileFormComponent];
}
